'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_SUMMARIES_REQUEST: 'FETCH_SUMMARIES_REQUEST',
    FETCH_SUMMARIES_SUCCEEDED: 'FETCH_SUMMARIES_SUCCEEDED',
    FETCH_SUMMARIES_FAILED: 'FETCH_SUMMARIES_FAILED',
    FETCH_SUMMARY_REQUEST: 'FETCH_SUMMARY_REQUEST',
    FETCH_SUMMARY_SUCCEEDED: 'FETCH_SUMMARY_SUCCEEDED',
    FETCH_SUMMARY_FAILED: 'FETCH_SUMMARY_FAILED',
    EDIT_SUMMARY_REQUEST: 'EDIT_SUMMARY_REQUEST',
    EDIT_SUMMARY_SUCCEEDED: 'EDIT_SUMMARY_SUCCEEDED',
    EDIT_SUMMARY_FAILED: 'EDIT_SUMMARY_FAILED',
    EDIT_SUMMARY_CANCELED: 'EDIT_SUMMARY_CANCELED',
    CHANGE_FILTER: 'CHANGE_FILTER',
    APPLY_FILTER_ERROR: 'APPLY_FILTER_ERROR',
    CLEAR_SUMMARIES_FILTER: 'CLEAR_SUMMARIES_FILTER'
};

function fetchSummariesRequest(filter) {
    return {
        type: actionTypes.FETCH_SUMMARIES_REQUEST,
        filter: filter
    };
}

function fetchSummariesSucceeded(summaries, filter) {
    return {
        type: actionTypes.FETCH_SUMMARIES_SUCCEEDED,
        summaries: summaries,
        filter: filter
    };
}

function fetchSummariesFailed(message) {
    return {
        type: actionTypes.FETCH_SUMMARIES_FAILED,
        message: message
    };
}

function fetchSummaryRequest(summaryId) {
    return {
        type: actionTypes.FETCH_SUMMARY_REQUEST,
        summaryId: summaryId
    };
}

function fetchSummarySucceeded(summary) {
    return {
        type: actionTypes.FETCH_SUMMARY_SUCCEEDED,
        summary: summary
    };
}

function fetchSummaryFailed() {
    return {
        type: actionTypes.FETCH_SUMMARY_FAILED
    };
}

function editSummaryRequest(summaryId, summary, redirect) {
    return {
        type: actionTypes.EDIT_SUMMARY_REQUEST,
        summaryId: summaryId,
        summary: summary,
        redirect: redirect
    };
}

function editSummarySucceeded() {
    return {
        type: actionTypes.EDIT_SUMMARY_SUCCEEDED
    };
}

function editSummaryFailed() {
    return {
        type: actionTypes.EDIT_SUMMARY_FAILED
    };
}

function editSummaryCanceled() {
    return {
        type: actionTypes.EDIT_SUMMARY_CANCELED
    };
}

function changeFilter(key, value) {
    return {
        type: actionTypes.CHANGE_FILTER,
        key: key,
        value: value
    };
}

function clearSummariesFilter() {
    return {
        type: actionTypes.CLEAR_SUMMARIES_FILTER
    };
}

var actionCreators = {
    fetchSummariesRequest: fetchSummariesRequest,
    fetchSummariesSucceeded: fetchSummariesSucceeded,
    fetchSummariesFailed: fetchSummariesFailed,
    fetchSummaryRequest: fetchSummaryRequest,
    fetchSummarySucceeded: fetchSummarySucceeded,
    fetchSummaryFailed: fetchSummaryFailed,
    editSummaryRequest: editSummaryRequest,
    editSummarySucceeded: editSummarySucceeded,
    editSummaryFailed: editSummaryFailed,
    editSummaryCanceled: editSummaryCanceled,
    changeFilter: changeFilter,
    clearSummariesFilter: clearSummariesFilter
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/summaries.js
// module id = 343
// module chunks = 0